<template>
  <div :class="`${containerClasses} h-[60px] md:h-[70px] w-full`">
    <div
      class="w-[95%] md:w-[90%] mx-auto grid grid-cols-3 px-3 md:px-5 h-full text-xl"
    >
      <div class="text-left items-center justify-start flex">
        <component :is="getComponentByPosition('left')" />
      </div>
      <div
        class="text-center items-center justify-center justify-items-center flex py-2 relative overflow-hidden"
      >
        <component :is="getComponentByPosition('center')" />
      </div>
      <div class="text-right items-center justify-end flex">
        <component :is="getComponentByPosition('right')" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapWritableState } from "pinia";
import { useAppStore } from "@/app-store/app";
import { useSessionStore } from "@/app-store/session";
import { PLATFORM } from "@/utils/constants";
import menuButton from "@/components/navbar/menu.vue";
import Logo from "@/components/navbar/logo.vue";
import NavbarLogin from "@/components/navbar/login.vue";
export default {
  name: "NavBar",
  components: { NavbarLogin, Logo, menuButton },
  data: () => ({
    PLATFORM,
  }),
  computed: {
    ...mapWritableState(useAppStore, [
      "layoutConfig",
      "shop",
      "isAccountModalOpen",
    ]),
    ...mapWritableState(useSessionStore, ["userInfo", "loyaltyCard", "cart"]),
    containerClasses() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.navbar) return "";
      return `bg-color-${layoutConfig.navbar.containerColor} text-color-${layoutConfig.navbar.textColor} font-${layoutConfig.navbar.font} text-${layoutConfig.navbar.textSize}`;
    },
    cartIconColor() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.navbar || !layoutConfig.theme)
        return "black";
      return layoutConfig.theme.colors[layoutConfig.navbar.textColor];
    },
  },
  methods: {
    getComponentByPosition(position) {
      const defaultPositions = {
        left: "menu-button",
        center: "logo",
        right: "navbar-login",
      };

      if (this.layoutConfig && this.layoutConfig.navbar) {
        if (this.layoutConfig.navbar.logoPosition === position) return "logo";
        if (this.layoutConfig.navbar.menuPosition === position)
          return "menu-button";
        if (this.layoutConfig.navbar.loginPosition === position)
          return "navbar-login";
      }
      return defaultPositions[position];
    },
  },
};
</script>

<style scoped></style>
